import type React from 'react';

export const CategoriesTilesSlots = {
  Header: ({ children }: React.PropsWithChildren) => children,
} as const satisfies Record<string, React.FC<React.PropsWithChildren>>;
